// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "component/encoder/v1/encoder.proto" (package "viam.component.encoder.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { GetGeometriesResponse } from "../../../common/v1/common";
import { GetGeometriesRequest } from "../../../common/v1/common";
import { GetStatusResponse } from "../../../common/v1/common";
import { GetStatusRequest } from "../../../common/v1/common";
import { DoCommandResponse } from "../../../common/v1/common";
import { DoCommandRequest } from "../../../common/v1/common";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { Struct } from "../../../google/protobuf/struct";
/**
 * @generated from protobuf message viam.component.encoder.v1.GetPositionRequest
 */
export interface GetPositionRequest {
    /**
     * Name of encoder
     *
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * If supplied, the response will return the specified
     * position type. If the driver does not implement
     * the requested type, this call will return an error.
     * If position type is not specified, the response
     * will return a default according to the driver.
     *
     * @generated from protobuf field: optional viam.component.encoder.v1.PositionType position_type = 2;
     */
    positionType?: PositionType;
    /**
     * Additional arguments to the method
     *
     * @generated from protobuf field: google.protobuf.Struct extra = 99;
     */
    extra?: Struct;
}
/**
 * @generated from protobuf message viam.component.encoder.v1.GetPositionResponse
 */
export interface GetPositionResponse {
    /**
     * @generated from protobuf field: float value = 1;
     */
    value: number;
    /**
     * @generated from protobuf field: viam.component.encoder.v1.PositionType position_type = 2;
     */
    positionType: PositionType;
}
/**
 * @generated from protobuf message viam.component.encoder.v1.ResetPositionRequest
 */
export interface ResetPositionRequest {
    /**
     * Name of an encoder
     *
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * Additional arguments to the method
     *
     * @generated from protobuf field: google.protobuf.Struct extra = 99;
     */
    extra?: Struct;
}
/**
 * @generated from protobuf message viam.component.encoder.v1.ResetPositionResponse
 */
export interface ResetPositionResponse {
}
/**
 * @generated from protobuf message viam.component.encoder.v1.GetPropertiesRequest
 */
export interface GetPropertiesRequest {
    /**
     * Name of the encoder
     *
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * Additional arguments to the method
     *
     * @generated from protobuf field: google.protobuf.Struct extra = 99;
     */
    extra?: Struct;
}
/**
 * @generated from protobuf message viam.component.encoder.v1.GetPropertiesResponse
 */
export interface GetPropertiesResponse {
    /**
     * @generated from protobuf field: bool ticks_count_supported = 1;
     */
    ticksCountSupported: boolean;
    /**
     * @generated from protobuf field: bool angle_degrees_supported = 2;
     */
    angleDegreesSupported: boolean;
}
/**
 * @generated from protobuf enum viam.component.encoder.v1.PositionType
 */
export enum PositionType {
    /**
     * @generated from protobuf enum value: POSITION_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * Return type for relative encoders that report
     * how far they've gone from a start position
     *
     * @generated from protobuf enum value: POSITION_TYPE_TICKS_COUNT = 1;
     */
    TICKS_COUNT = 1,
    /**
     * Return type for absolute encoders that report
     * their position in degrees along the radial axis
     *
     * @generated from protobuf enum value: POSITION_TYPE_ANGLE_DEGREES = 2;
     */
    ANGLE_DEGREES = 2
}
// @generated message type with reflection information, may provide speed optimized methods
class GetPositionRequest$Type extends MessageType<GetPositionRequest> {
    constructor() {
        super("viam.component.encoder.v1.GetPositionRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "position_type", kind: "enum", opt: true, T: () => ["viam.component.encoder.v1.PositionType", PositionType, "POSITION_TYPE_"] },
            { no: 99, name: "extra", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.encoder.v1.GetPositionRequest
 */
export const GetPositionRequest = new GetPositionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPositionResponse$Type extends MessageType<GetPositionResponse> {
    constructor() {
        super("viam.component.encoder.v1.GetPositionResponse", [
            { no: 1, name: "value", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 2, name: "position_type", kind: "enum", T: () => ["viam.component.encoder.v1.PositionType", PositionType, "POSITION_TYPE_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.encoder.v1.GetPositionResponse
 */
export const GetPositionResponse = new GetPositionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResetPositionRequest$Type extends MessageType<ResetPositionRequest> {
    constructor() {
        super("viam.component.encoder.v1.ResetPositionRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 99, name: "extra", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.encoder.v1.ResetPositionRequest
 */
export const ResetPositionRequest = new ResetPositionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResetPositionResponse$Type extends MessageType<ResetPositionResponse> {
    constructor() {
        super("viam.component.encoder.v1.ResetPositionResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.encoder.v1.ResetPositionResponse
 */
export const ResetPositionResponse = new ResetPositionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPropertiesRequest$Type extends MessageType<GetPropertiesRequest> {
    constructor() {
        super("viam.component.encoder.v1.GetPropertiesRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 99, name: "extra", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.encoder.v1.GetPropertiesRequest
 */
export const GetPropertiesRequest = new GetPropertiesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPropertiesResponse$Type extends MessageType<GetPropertiesResponse> {
    constructor() {
        super("viam.component.encoder.v1.GetPropertiesResponse", [
            { no: 1, name: "ticks_count_supported", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "angle_degrees_supported", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.encoder.v1.GetPropertiesResponse
 */
export const GetPropertiesResponse = new GetPropertiesResponse$Type();
/**
 * @generated ServiceType for protobuf service viam.component.encoder.v1.EncoderService
 */
export const EncoderService = new ServiceType("viam.component.encoder.v1.EncoderService", [
    { name: "GetPosition", options: { "google.api.http": { get: "/viam/api/v1/component/encoder/{name}/get_position" } }, I: GetPositionRequest, O: GetPositionResponse },
    { name: "ResetPosition", options: { "google.api.http": { get: "/viam/api/v1/component/encoder/{name}/reset_position" } }, I: ResetPositionRequest, O: ResetPositionResponse },
    { name: "GetProperties", options: { "google.api.http": { post: "/viam/api/v1/component/encoder/{name}/get_properties" } }, I: GetPropertiesRequest, O: GetPropertiesResponse },
    { name: "DoCommand", options: { "google.api.http": { post: "/viam/api/v1/component/encoder/{name}/do_command" } }, I: DoCommandRequest, O: DoCommandResponse },
    { name: "GetStatus", options: { "google.api.http": { get: "/viam/api/v1/component/encoder/{name}/get_status" } }, I: GetStatusRequest, O: GetStatusResponse },
    { name: "GetGeometries", options: { "google.api.http": { get: "/viam/api/v1/component/encoder/{name}/geometries" } }, I: GetGeometriesRequest, O: GetGeometriesResponse }
]);
